"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectKeys = void 0;
/** Object.keys() with types */
function objectKeys(o) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Object.keys(o);
}
exports.objectKeys = objectKeys;